import styled from 'styled-components';

import earningsBack from '../../assets/images/earningsBack.png';

export const DashboardNotificationComponent = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
`;

export const NotificationPill = styled.div`
  background: ${(props) => props.theme.colors.secondaryBlue};
  border-radius: 12px;
  padding: 10px;
  margin-bottom: 12px;
  color: ${(props) => props.theme.colors.neutral500};
  text-transform: uppercase;
  font-size: 12px;
  line-height: 140%;
  display: inline-flex;
  font-weight: 500;
`;

export const IconTitleStyled = styled.h1`
  font-weight: 600;
  font-size: 22px;
  line-height: 32px;
  color: ${(props) => props.theme.colors.neutral900};
  margin-bottom: 24px;

  display: flex;
  align-items: center;

  img {
    margin-right: 12px;
    width: 40px;
  }

  @media (max-width: 800px) {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 16px;
    img {
      width: 32px;
    }
  }
`;

export const CashBackFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const RedCircle = styled.div`
  height: 280px;
  aspect-ratio: 1 / 1;
  border: 3px solid ${(props) => props.theme.colors.error500};
  padding: 3px;
  border-radius: 50%;
  > div {
    width: 100%;
    height: 100%;
    border: 30px solid ${(props) => props.theme.colors.error500};
    border-radius: 50%;
    aspect-ratio: 1 / 1;
  }
`;

export const EarningsSmall = styled.div<{ earnings?: string }>`
  display: grid;
  width: 100%;

  grid-template-columns: ${(props) =>
    props.earnings ? 'repeat(2, 1fr)' : 'repeat(3, 1fr)'};

  grid-column-gap: 24px;
  grid-row-gap: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 1000px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 335px) {
    grid-template-columns: repeat(1, 1fr);
  }
  > div {
    cursor: pointer;
  }
  @media (max-width: 800px) {
    grid-column-gap: 12px;
    grid-row-gap: 12px;
    > div {
      padding: 12px;
    }
  }
`;

export const Statistical = styled(EarningsSmall)`
  > div {
    cursor: pointer;
    img {
      margin-right: 16px;
      width: 32px;
    }
  }
`;

export const BackOfficeNumbersWrap = styled.div`
  display: flex;
  justify-content: space-between;
  > div {
    width: calc(50% - 20px);

    > div {
      box-shadow: ${(props) => props.theme.shadows.shadowXS};
      background: ${(props) => props.theme.colors.neutral50};
      border-radius: 12px;
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    @media (max-width: 800px) {
      width: 100%;
      margin-bottom: 20px;
    }
  }
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const BackOfficeNumbers = styled.div<{ orange?: boolean }>`
  width: calc(100% / 8 - 6px);
  background: ${(props) =>
    props.orange
      ? (props) => props.theme.colors.secondary100
      : (props) => props.theme.colors.primary900};
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 36px;
  line-height: 42px;
  color: ${(props) =>
    props.orange
      ? (props) => props.theme.colors.neutral50
      : (props) => props.theme.colors.neutral50};
  height: 56px;
  @media (max-width: 800px) {
    font-size: 16px;
    line-height: 20px;
    height: 36px;
  }
`;

export const Title = styled.div`
  font-weight: 500;
  font-size: 24px;
  line-height: 32px;
  text-align: center;
  color: ${(props) => props.theme.colors.neutral900};
  margin-bottom: 8px;
  @media (max-width: 800px) {
    font-size: 20px;
    line-height: 24px;
  }
`;

export const Subtitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors.neutral500};
  margin-bottom: 40px;
`;

export const Image = styled.img`
  width: 160px;
  margin-bottom: 40px;
`;

export const Username = styled.div`
  position: absolute;
  bottom: -10px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  padding: 12px 12px;
  background: ${(props) => props.theme.colors.neutral50};
  border-radius: 22px;
  opacity: 0.95;
  width: 100%;
`;

export const CountdownNumbers = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  /* flex-direction: column; */
  justify-content: center;
  > div {
    width: 56px;
    margin: 7px;
    display: flex;
    flex-direction: column;
    align-items: center;

    div {
      color: ${(props) => props.theme.colors.error500};
    }
    @media (max-width: 800px) {
      width: calc(25% - 30px);
    }
  }
  img {
    width: 100%;
  }
`;

export const IconPosition = styled.div`
  display: flex;
  align-self: start;
`;

export const SlideWrapper = styled.div`
  width: 100%;
  margin-bottom: 20px;
  img {
    width: 100%;
  }

  .swiper-button-next,
  .swiper-button-next::after,
  .swiper-button-prev,
  .swiper-button-prev::after {
    color: ${({ theme }) => theme.colors.primary900};
    font-size: 30px;
  }
`;

export const TopPerformerComponent = styled.div`
  display: flex;
  flex-direction: column;
`;

export const TopPerformerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.5);
  backdrop-filter: blur(10px);
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DashboardUnderlay = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  background: url(${earningsBack}) no-repeat center center;
  background-size: cover;
  position: relative;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const InviteLinks = styled.div`
  width: 100%;
  border-radius: 200px;
  background: ${(props) => props.theme.colors.primary900};
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
`;

export const ReferralLink = styled.div`
  width: 100%;
  border-radius: 30px;
  background: ${(props) => props.theme.colors.neutral100};
  color: ${(props) => props.theme.colors.neutral900};
  padding: 10px 20px;
  word-break: break-all;
`;

export const BannerWrapper = styled.div`
  position: relative;
  width: 100%;
  container-type: inline-size;

  img {
    width: 100%;
    display: block;
  }
`;

export const BannerText = styled.p`
  position: absolute;
  left: 4.5%;
  top: 65%;
  width: 28%;
  margin: 0;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 1.1cqw;
  line-height: 1.45;
  letter-spacing: 0.02em;

  span {
    color: #c2a686;
    font-weight: 600;
  }
`;

export const BannerTextMobile = styled.p`
  position: absolute;
  left: 15%;
  top: 45%;
  margin: 0;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 4cqw;
  line-height: 1.45;
  letter-spacing: 0.02em;

  span {
    color: #c2a686;
    font-weight: 600;
  }
`;

export const JourneyCard = styled.div`
  position: relative;
  width: 100%;
  border-radius: 24px;
  overflow: hidden;
  padding: 40px 32px;

  @media (max-width: 800px) {
    padding: 28px 20px;
    border-radius: 16px;
  }
`;

export const JourneyPattern = styled.div<{ bg: string }>`
  position: absolute;
  inset: 0;
  background: url(${(props) => props.bg}) no-repeat center center;
  background-size: cover;
  opacity: 0.7;
  pointer-events: none;
`;

export const JourneyContent = styled.div`
  position: relative;
  z-index: 1;
`;

export const JourneyStep = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }

  @media (max-width: 800px) {
    gap: 12px;
    margin-bottom: 24px;
  }
`;

export const StepIcon = styled.div<{ completed?: boolean }>`
  flex-shrink: 0;
  width: 56px;
  height: 56px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) =>
    props.completed
      ? 'linear-gradient(145deg, #16b410 0%, #16b410 100%)'
      : 'linear-gradient(145deg, #c2a686 0%, #a68b63 100%)'};

  img,
  svg {
    width: 26px;
    height: 26px;
  }

  @media (max-width: 800px) {
    width: 44px;
    height: 44px;
    border-radius: 12px;

    img,
    svg {
      width: 20px;
      height: 20px;
    }
  }
`;

export const StepBody = styled.div`
  flex: 1;
  min-width: 0;
`;

export const StepHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const StepTitle = styled.h3<{ muted?: boolean }>`
  margin: 0 0 6px 0;
  font-size: 30px;
  line-height: 1.25;
  font-weight: 700;
  color: ${(props) =>
    props.muted ? '#6b6b7b' : props.theme.colors.primary900};

  @media (max-width: 800px) {
    font-size: 17px;
  }
`;

export const StepDescription = styled.p`
  margin: 0;
  font-size: 18px;
  line-height: 1.45;
  color: #4a4a55;

  @media (max-width: 800px) {
    font-size: 13px;
  }
`;

export const ClaimButton = styled.button`
  border: none;
  cursor: pointer;
  padding: 12px 26px;
  border-radius: 999px;
  background: ${(props) => props.theme.colors.primary900};
  color: ${(props) => props.theme.colors.neutral50};
  font-size: 15px;
  white-space: nowrap;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.85;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const EnrollDots = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 12px;
  vertical-align: middle;
`;

export const EnrollDot = styled.span<{ active?: boolean }>`
  width: 14px;
  height: 14px;
  display: inline-block;
  background-color: ${(props) => (props.active ? '#22c55e' : '#c9c9d1')};
  mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 12a5 5 0 100-10 5 5 0 000 10zm0 2c-5 0-9 2.5-9 5.5V21h18v-1.5c0-3-4-5.5-9-5.5z"/></svg>')
    no-repeat center / contain;
`;

export const JourneyDivider = styled.div`
  height: 1px;
  width: 100%;
  background: #d4d4da;
  margin: 40px 0;

  @media (max-width: 800px) {
    margin: 28px 0;
  }
`;

export const StatsRow = styled.div`
  display: flex;
  gap: 40px;
  margin-top: 20px;
  flex-wrap: wrap;

  @media (max-width: 800px) {
    gap: 24px;
  }
`;

export const StatLabel = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  text-transform: uppercase;
  color: #6b6b7b;
  margin-bottom: 4px;

  @media (max-width: 800px) {
    font-size: 13px;
  }
`;

export const StatValue = styled.div`
  font-size: 26px;
  font-weight: 500;
  color: ${(props) => props.theme.colors.primary900};

  small {
    font-size: 14px;
    margin-left: 6px;
    text-transform: uppercase;
  }

  @media (max-width: 800px) {
    font-size: 20px;

    small {
      font-size: 11px;
    }
  }
`;

export const InfoTooltip = styled.span`
  position: relative;
  display: inline-flex;
  cursor: pointer;

  &::after {
    content: attr(data-tip);
    position: absolute;
    bottom: calc(100% + 8px);
    right: -8px;
    width: 210px;
    padding: 10px 12px;
    border-radius: 10px;
    background: #101014;
    color: #ffffff;
    font-size: 12px;
    line-height: 1.35;
    text-align: center;
    text-transform: none;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease;
    z-index: 5;
  }

  &:hover::after {
    opacity: 1;
    visibility: visible;
  }
`;
